import { getAppUrl } from "@linkfluence/konf";
import { App } from "@linkfluence/models/app";
// import { Clause } from "@radarly/models/clause";
// import {
//   getLegacyUrlQuerySeparator,
//   transformClauseToLegacyQueryString,
//   transformPeriodToLegacyRange,
// } from "@radarly/models/clause/transformer";
import { Page } from "./pages";

const nest = (start: string, end: string) => start + end;

const settings = (path: string) => nest("/settings", path);

const project = (path: string) => nest("/project/:project", path);

const workspace = (path: string) =>
  project(nest("/dashboard/:dashboard", path));

const listening = (path: string) => workspace(nest("/listening", path));

const youtube = (path: string) => listening(nest("/youtube", path));

const owned = (path: string) => workspace(nest("/performance/mybrands", path));

const benchmark = (path: string) =>
  workspace(nest("/performance/benchmark", path));

const projectSettings = (path: string) => settings(project(path));

const projectInsightPages = (path: string) => project(nest("/pages", path));
const insightPages = (path: string) => workspace(nest("/pages", path));

export const Route = {
  // Home
  home: "/",
  // Project home
  projectHome: project("/home"),
  // Workspace home
  workspaceHome: workspace("/home"),
  // Listening
  listeningQueriesOverview: listening("/overview"),
  listeningAnalytics: listening("/details"),
  listeningInfluencers: listening("/influencers"),
  listeningLiveMonitoring: listening("/live"),
  listeningClusters: listening("/clusters"),
  listeningYoutubeAnalytics: youtube("/analytics"),
  listeningYoutubeInfluencers: youtube("/channels"),
  listeningContentLandscape: listening("/emotionalmap"),
  // Social Peformance - Owned Media
  socialPerformanceOwnedOverview: owned("/overview"),
  socialPerformanceOwnedDetails: owned("/details"),
  socialPerformanceOwnedPosts: owned("/posts"),
  socialPerformanceOwnedFollowersMap: owned("/map"),
  // Social Perfomance - Benchmark
  socialPerformanceBenchmarkOverview: benchmark("/ranking"),
  socialPerformanceBenchmarkDetails: benchmark("/details"),
  socialPerformanceBenchmarkDuel: benchmark("/battle"),
  // Insight Pages
  insightPagesHome: projectInsightPages("/home"),
  insightPagesList: insightPages("/home"),
  insightPagesPage: insightPages("/page"),
  insightPagesGlobalPage: projectInsightPages("/page"),
  insightPagesEditor: insightPages("/editor"),
  insightPagesGlobalEditor: projectInsightPages("/editor"),
  insightPagesWizardEditor: insightPages("/wizard"),
  sharedInsightPage: "/shared",
  discovery: workspace("/discovery"),
  imageClustering: workspace("/image-clustering"),

  // settings
  settingsHome: projectSettings("/home"),
  settingsWorkspace: projectSettings("/dashboards/:dashboard"),
  noProject: "/no_project",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
type Route = typeof Route[keyof typeof Route];

const PageRoute: Partial<Record<Page, Route>> = {
  [Page.home]: Route.home,
  [Page.projectHome]: Route.projectHome,
  [Page.workspaceHome]: Route.workspaceHome,
  [Page.insightPagesHome]: Route.insightPagesHome,
  [Page.insightPagesList]: Route.insightPagesList,
  [Page.insightPagesPage]: Route.insightPagesPage,
  [Page.insightPagesGlobalPage]: Route.insightPagesGlobalPage,
  [Page.insightPagesEditor]: Route.insightPagesEditor,
  [Page.insightPagesGlobalEditor]: Route.insightPagesGlobalEditor,
  [Page.insightPagesWizardEditor]: Route.insightPagesWizardEditor,
  [Page.discovery]: Route.discovery,
  [Page.sharedInsightPage]: Route.sharedInsightPage,
  [Page.listeningQueriesOverview]: Route.listeningQueriesOverview,
  [Page.listeningAnalytics]: Route.listeningAnalytics,
  [Page.listeningInfluencers]: Route.listeningInfluencers,
  [Page.listeningLiveMonitoring]: Route.listeningLiveMonitoring,
  [Page.listeningClusters]: Route.listeningClusters,
  [Page.listeningYoutubeAnalytics]: Route.listeningYoutubeAnalytics,
  [Page.listeningYoutubeInfluencers]: Route.listeningYoutubeInfluencers,
  [Page.listeningContentLandscape]: Route.listeningContentLandscape,
  [Page.socialPerformanceOwnedOverview]: Route.socialPerformanceOwnedOverview,
  [Page.socialPerformanceOwnedDetails]: Route.socialPerformanceOwnedDetails,
  [Page.socialPerformanceOwnedPosts]: Route.socialPerformanceOwnedPosts,
  [Page.socialPerformanceOwnedFollowersMap]:
    Route.socialPerformanceOwnedFollowersMap,
  [Page.socialPerformanceBenchmarkOverview]:
    Route.socialPerformanceBenchmarkOverview,
  [Page.socialPerformanceBenchmarkDetails]:
    Route.socialPerformanceBenchmarkDetails,
  [Page.socialPerformanceBenchmarkDuel]: Route.socialPerformanceBenchmarkDuel,
  [Page.settingsHome]: Route.settingsWorkspace,
  [Page.settingsWorkspace]: Route.settingsWorkspace,
  [Page.noProject]: Route.noProject,
  [Page.imageClustering]: Route.imageClustering,
};

// function isPagePreservingFilters(page: Page) {
//   const analyticsPages: Page[] = [
//     Page.listeningQueriesOverview,
//     Page.listeningAnalytics,
//     Page.listeningInfluencers,
//     Page.listeningLiveMonitoring,
//     Page.listeningClusters,
//     Page.listeningYoutubeAnalytics,
//     Page.listeningYoutubeInfluencers,
//     Page.listeningContentLandscape,
//   ];
//   return analyticsPages.includes(page);
// }

export function getRouteFromPage(page: Page) {
  return PageRoute[page];
}

export function getNotImplementedPageUrl(url: string): string {
  const pageUrl = `${getAppUrl(App.Radarly)}#${url}`;
  return pageUrl;
}
